/**
 * API Endpoints documentation page
 */

import {DocsContent} from '../../../components/docs/DocsContent';
import {CodeBlock} from '../../../components/docs/CodeBlock';
import {DocsTable} from '../../../components/docs/DocsTable';
import {DocsActionButtons} from '../../../components/docs/DocsActionButtons';

export function APIEndpoints() {
  return (
    <DocsContent
      title="API Endpoints"
      description="Complete reference for all VoxaPilot API endpoints."
    >
      <div className="space-y-8">
        <section>
          <h2 className="text-2xl font-bold text-textPrimary mb-4">Meetings</h2>

          <h3 className="text-xl font-semibold text-textPrimary mb-3 mt-6">List Meetings</h3>
          <CodeBlock
            code={`GET /v1/meetings

// Response
{
  "success": true,
  "data": [
    {
      "id": "meeting-123",
      "title": "Team Standup",
      "status": "completed",
      "createdAt": "2024-01-15T10:00:00Z"
    }
  ]
}`}
            language="http"
          />

          <h3 className="text-xl font-semibold text-textPrimary mb-3 mt-6">Get Meeting</h3>
          <CodeBlock
            code={`GET /v1/meetings/{id}

// Response
{
  "success": true,
  "data": {
    "id": "meeting-123",
    "title": "Team Standup",
    "transcript": "...",
    "summary": "...",
    "actionItems": [...]
  }
}`}
            language="http"
          />

          <h3 className="text-xl font-semibold text-textPrimary mb-3 mt-6">Create Meeting</h3>
          <CodeBlock
            code={`POST /v1/meetings
Content-Type: application/json

{
  "title": "Team Standup",
  "platform": "zoom",
  "meetingId": "123456789"
}

// Response
{
  "success": true,
  "data": {
    "id": "meeting-123",
    "status": "recording"
  }
}`}
            language="http"
          />
        </section>

        <section>
          <h2 className="text-2xl font-bold text-textPrimary mb-4">Transcripts</h2>

          <h3 className="text-xl font-semibold text-textPrimary mb-3 mt-6">Get Transcript</h3>
          <CodeBlock
            code={`GET /v1/meetings/{id}/transcript

// Response
{
  "success": true,
  "data": {
    "segments": [
      {
        "speaker": "John Doe",
        "text": "Let's start the meeting...",
        "timestamp": 0.5,
        "startTime": "00:00:00",
        "endTime": "00:00:03"
      }
    ]
  }
}`}
            language="http"
          />
        </section>

        <section>
          <h2 className="text-2xl font-bold text-textPrimary mb-4">Summaries</h2>

          <h3 className="text-xl font-semibold text-textPrimary mb-3 mt-6">Generate Summary</h3>
          <CodeBlock
            code={`POST /v1/meetings/{id}/summarize
Content-Type: application/json

{
  "includeActionItems": true,
  "includeDecisions": true,
  "model": "gpt-4-turbo"
}

// Response
{
  "success": true,
  "data": {
    "summary": "...",
    "actionItems": [...],
    "decisions": [...]
  }
}`}
            language="http"
          />
        </section>

        <section>
          <h2 className="text-2xl font-bold text-textPrimary mb-4">Error Codes</h2>
          <DocsTable
            headers={['Code', 'Status', 'Description']}
            rows={[
              ['INVALID_API_KEY', '401', 'API key is missing or invalid'],
              ['RATE_LIMIT_EXCEEDED', '429', 'Too many requests'],
              ['NOT_FOUND', '404', 'Resource not found'],
              ['VALIDATION_ERROR', '400', 'Invalid request data'],
              ['INTERNAL_ERROR', '500', 'Server error'],
            ]}
          />
        </section>

        <DocsActionButtons pageTitle="API Endpoints" />
      </div>
    </DocsContent>
  );
}

